// Where a QA Rules targeting-summary entry's list is actually assigned (backend
// `assigned_at`, 2026-10-15). A program/component page also lists the lists
// assigned to the goals/components beneath it, but "×" can only unassign at the
// level being viewed, so for those it used to remove nothing and look broken
// (SailPoint report). `here` = assigned at the level+entity being viewed.
// An entry with no `assigned_at` (suppression lists, an older payload) behaves
// as before: removable.
const ASSIGNMENT_LEVEL_LABELS = { program: 'Program', component: 'Component', goal: 'Goal' };

export function assignmentPlaces(tl, level, entityId) {
  const places = tl.assigned_at;
  if (!places || places.length === 0) return { here: true, elsewhere: [] };
  const isHere = (p) => p.level === level && Number(p.entity_id) === Number(entityId);
  return { here: places.some(isHere), elsewhere: places.filter((p) => !isHere(p)) };
}

export function placeLabel(p) {
  const base = ASSIGNMENT_LEVEL_LABELS[p.level] || p.level;
  return p.entity_name ? `${base}: ${p.entity_name}` : base;
}
